import React from 'react';

import { useTranslation } from 'react-i18next/';
import { useParams } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container, LoadingSpinner } from '@ttstr/components';

import { confirmSubscription } from '@ttstr/api';

interface RouterParams {
  token: string;
}

const NewsletterSubscribeFinisher: React.FC = () => {
  const { t } = useTranslation();
  const [success, setSuccess] = React.useState<boolean>(null);
  const [processing, setProcessing] = React.useState<boolean>(true);
  const params = useParams<RouterParams>();

  async function confirmNewsletter(token: string) {
    try {
      await confirmSubscription(token);
    } catch (error) {
      setProcessing(false);
      setSuccess(false);
    } finally {
      setProcessing(false);
      setSuccess(true);
    }
  }

  React.useEffect(() => {
    confirmNewsletter(params.token);
  }, []);

  return (
    <article className="mt-5 newsletter-unsubscribe-finisher">
      <Container>
        <h1 className="text-center mb-4">{t(`NEWSLETTER.SUBSCRIBED.TITLE`)}</h1>
        <Row>
          <Col lg={{ size: 6, offset: 3 }}>
            <p className="text-justify newsletter-subscribed-text text-center">
              Get exclusive access to the Nacar Tour 2026 ticket presale now!
            </p>
            <p className="text-center">
              <a href="/CG/ns7Gevdo" className="btn btn-primary">
                Get your tickets!
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(NewsletterSubscribeFinisher);
